import React from "react";
//#region types
import { FileUploaderErrorProps } from "models/propTypes/fileUploaderPropTypes";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ErrorMessage from "../../../errorViews/errorMessage";
import FixedMessageBubble from "../../../messages/fixedMessageBubble";
//#endregion
//#region helpers
import { LocalizationHelperInstance } from "utils/helpers";
//#endregion

const FileUploaderErrors: React.FC<FileUploaderErrorProps> = (props) => {
  const {
    invalidFileType,
    invalidFileSize,
    hasEmptyFile,
    beyondMaxAmountOfFiles,
    uploadedOnlyMax,
    maxFileSize,
    allowedMaxFileCount,
    errorBubbles,
  } = props;

  const maxAmountOfFilesMessage = LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.Errors.MaxAmountOfFilesAllowed,
    undefined,
    {
      number: allowedMaxFileCount.toString(),
    }
  );

  const beyondMaxFilesMessage = LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.Errors.BeyondMaxAmountOfFiles,
    undefined,
    {
      number: allowedMaxFileCount.toString(),
    }
  );

  const invalidFileTypeMessage = `${LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.Errors.InvalidFileType
  )}`;

  const aboveMaxFileSizeMessage = `${LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.Errors.LargerThanMaxFileSize
  )} ${maxFileSize}`;

  const emptyFileMessage = `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.EmptyFile)}`;

  const errorMessage = React.useMemo(() => {
    const errorMessages = [];

    if (beyondMaxAmountOfFiles) {
      errorMessages.push(maxAmountOfFilesMessage);
      if (uploadedOnlyMax) {
        errorMessages.push(`\n\n${beyondMaxFilesMessage}`);
      }
    }

    if (invalidFileType) {
      errorMessages.push(invalidFileTypeMessage);
    }

    if (invalidFileSize) {
      errorMessages.push(aboveMaxFileSizeMessage);
    }

    if (hasEmptyFile) {
      errorMessages.push(emptyFileMessage);
    }

    return errorMessages.join(" ");
  }, [errorBubbles, beyondMaxAmountOfFiles, invalidFileType, invalidFileSize, hasEmptyFile]);

  return (
    <React.Fragment>
      {errorBubbles ? (
        <FixedMessageBubble
          message={{
            message: errorMessage,
            type: StyleEnums.DisplayType.Danger,
          }}
        ></FixedMessageBubble>
      ) : (
        <ErrorMessage errorMessage={errorMessage}></ErrorMessage>
      )}
    </React.Fragment>
  );
};

export default FileUploaderErrors;
